// Stub: leftover path from the discarded analytics_log_restore UI.
// Kept so packs/custom require.context resolves cleanly. No Alpine component.
document.addEventListener('alpine:init', () => {
  // no-op
});
